<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <t-input v-model="form[fieldKey]" hidden/>

      <t-form-tab title="Dados Básicos">

        <t-input class="mb-2" v-model="form.name"  :add-error="error.name" label="Nome" required />

        <b-form-checkbox v-model="form.stockAllCompanies" switch>
          Habilitar para todas as empresas relacionadas?
          <t-help
              title="Desmarque esta opção, somente se desejar especificar para qual empresa está relacionado este estoque."/>
        </b-form-checkbox>

        <t-input v-if="!form.stockAllCompanies" v-model="form.companyId" placeholder="Selecione uma empresa"
                 :options="companyOptions" required label="Empresa" hide-label select/>

        <t-input class="mt-2" v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status" class="mb-2"/>

      </t-form-tab>

      <template #out-of-form>

        <t-form-tab hash="place-inside" title="Locais de Armazenamento"
                    :disabled="!relationAccessPageGeneral('stock-place-product-inside')" lazy>
          <StockProductInside :foreign-key="form[fieldKey]"/>
        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import StockProductInside from "@/views/modules/stock/StockPlaceProductInside";
import companyService from "@/services/modules/admin/Company.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'StockProductForm',
  components: {StockProductInside},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "stockPlaceProductId",
      form: {
        stockPlaceProductId: 0,
        stockAllCompanies: true,
        companyId: 0,
        name: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      companyOptions: [],

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      await companyService.selectList("").then((list) => {
        this.companyOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
